import { useEffect, useRef, useState } from 'react'
import { STATUSES, STATUS_LABELS } from '../util.js'

/** Shared by the card and the table row. stopPropagation throughout: both
 *  parents open the detail sheet on click, and setting a status must not. */
export default function StatusMenu({ onStatus }) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  // ARIA menu/menuitem implies dismissal on Escape and on an outside click —
  // without this the menu stays visibly open after a Dealer/Map click,
  // a scroll, or opening another card's menu. Listens on pointerdown (not
  // click) so it never races the stopPropagation()s below, and only while
  // open so no listener leaks once the menu is closed or the card unmounts.
  useEffect(() => {
    if (!open) return undefined
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    const onPointerDown = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('keydown', onKeyDown)
    document.addEventListener('pointerdown', onPointerDown)
    return () => {
      document.removeEventListener('keydown', onKeyDown)
      document.removeEventListener('pointerdown', onPointerDown)
    }
  }, [open])

  return (
    <span className="status-menu" ref={rootRef}>
      <button
        className="status-btn"
        aria-label="Set status"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o) }}
      >
        ⋯
      </button>
      {open && (
        <span className="status-list" role="menu">
          {STATUSES.map((s) => (
            <button
              key={s}
              role="menuitem"
              onClick={(e) => { e.stopPropagation(); setOpen(false); onStatus?.(s) }}
            >
              {STATUS_LABELS[s]}
            </button>
          ))}
          <button
            role="menuitem"
            onClick={(e) => { e.stopPropagation(); setOpen(false); onStatus?.('') }}
          >
            Clear
          </button>
        </span>
      )}
    </span>
  )
}
